import { Navigate } from "react-router-dom";
import LoginForm from "@/components/forms/LoginForm";
import { useAuth } from "@/hooks/useAuth";

const LoginPage = () => {
  const { loggedIn } = useAuth();

  if (loggedIn) {
   return <Navigate to="/reports/livewire?fullscreen=true&darkMode=true"   />;
  }

  return (
    <div className="page bg-primary">
      <div className="container bg-primary">
        <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
          <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

LoginPage.propTypes = {};

export default LoginPage;
